<template>
<div class="detail-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<div id="id_attache_show" style="display: none;"></div>
		<van-cell-group>
		    <van-cell class="detail-title">
		        <h2>{{new_details.TITLE}}</h2>
				<p class="attrs">
					<span class="c999 mt5 left pl20">{{this.sType}}</span>
					<span v-if="new_details.PUBLICDATE" class="c999 mt5 pr20 right">{{new_details.PUBLICDATE?new_details.PUBLICDATE.substr(0,10):new_details.PUBLISH_DATE.substr(0,10)}}</span>
				</p>
		    </van-cell>
		    <van-cell class="detail-content">
				<pre v-html="article_conent"></pre>
		    </van-cell>
		 </van-cell-group>
<!--		 <FooterNews></FooterNews> &lt;!&ndash; 尾部 &ndash;&gt;-->
	</div>
</div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
	    var $rus=this.$router.history;
		this.id=$rus["current"].query.id;
		var type=$rus["current"].query.type;
		if(type=="ittopic" && this.id==1509){
			this.$dialog.alert({
			  message: '此文章已被撤回',
			  showConfirmButton:false,
			  overlayClass:"error-user"
			});
			return false;
		}
		if(type==2){
			this.sType="公司新闻";
			this.nid=this.CoreNew.SYSTABLE.NEWS;
		}else if(type==1){
			this.sType="公司公告";
			this.nid=this.CoreNew.SYSTABLE.NEWS;
			//if(this.id==0){this.id=6394;}
		}else if(type=="ittopic"){
			this.sType="IT热点";
			this.nid=this.CoreNew.SYSTABLE.ITTOPICS;
		}else if(type=="together"){
			this.sType="在一起";
			this.nid=$rus["current"].query.nid;
		}
		this.getDetail();	
  },
  async mounted(){
	  var $rus=this.$router.history;
	  if($rus["current"].fullPath.indexOf('type=2') !== -1){
			this.page_title="内部新闻";
			document.title = "内部新闻";
	  }else if($rus["current"].fullPath.indexOf('type=ittopic') !== -1){
			this.page_title="IT热点";
			document.title = "IT热点";
	  }else if($rus["current"].fullPath.indexOf('type=together') !== -1){
			this.page_title="在一起";
			document.title = "在一起";
	  }else{
		    this.page_title="公司公告";
		    document.title = "公司公告";
	  }
	  
	  this.watermark.set(this.ADMIN.USER_NAME+"_"+this.ADMIN.USER_CODE); //水印
	  //滚动
	  window.addEventListener('scroll', function(){
	  		  $(".detail-page .detail-title").addClass("fixedtitle");
	  		  $(".detail-page .detail-content").css("margin-top",$(".detail-page .detail-title").height());
	  }, true);
	  //附件下载
	  await setTimeout(()=>{
		$(".detail-page .detail-content a").click(function(){
			var url=$(this).attr("data-val");   //请求的URl
			var xhr = new XMLHttpRequest();		//定义http请求对象
			xhr.open("GET", url, true);		
			xhr.setRequestHeader("Authorization",JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION')));
			xhr.send();
			xhr.responseType = "json";  //返回blob
			xhr.onload = function() { 
				if (this.status===200) {
					let url = this.response.message;
					let reg_url=new RegExp('//ueditor/','g')//g代表全部
					url=url.replace(reg_url,"/ueditor/");
					window.location.href=url;
					/*var a = document.createElement('a');
					a.href = url;
					document.body.appendChild(a);  
					a.click();
					document.body.removeChild(a);*/
				}else{
					return false;
				}
			}
		})
	  },500);
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  OA_API_URL:this.CoreNew.OA_API_URL,
	  URLTOKEN:encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
	  id:0,
	  nid:this.CoreNew.SYSTABLE.NEWS,
	  is_error_url:false,
	  sType:"公司公告",
	  new_details: [],
	  article_conent:"",
	};
   },
   filters: {
    },
    methods: {
	    onSubmitRead: function (read_status) { //更新阅读状态
			if(read_status=="N"){
				let json_data = {"ENTITY_CONFIG_ID":this.nid,"MESSAGE_ID":this.id,"USER_ID":localStorage.getItem('LS_ADMIN_USER_ID')};
				axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+this.CoreNew.SYSTABLE.COMM_TABLEID+"/",json_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					var $rs=response.data;
					console.log(response.data);
					if($rs.flag==true){}
				}.bind(this)).catch(function (error) { 
					$("#loading").hide();
					//alert("请求--文章--阅读状态--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--文章--阅读状态--失败"+error);//记录错误
					console.log("请求--文章--阅读状态--失败"+error);
				});
			}
	    },
		getDetail: function () {
			axios.get(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+this.nid+"/"+this.id+"/",{
	   			headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
	   		}).then(function (response) {
				console.log(response.data);
				if(response.data.flag==true){
					this.new_details=response.data.data;
					if(this.new_details.STATUS > 1){
						this.$dialog.alert({
						  message: '此文章已被撤回',
						  showConfirmButton:false,
						  overlayClass:"error-user"
						});
					}else{
						var a_content=this.new_details.CONTENT;
						let reg=new RegExp('href="https://portal.cecport.com/redirect?','g')//g代表全部
						this.article_conent=a_content.replace(reg,'data-val="'+this.OA_API_URL+"joa-business/attach/downloadToPath");
						//let reg_s=new RegExp('isDownload=Y','g')//g代表全部
						//this.article_conent=this.article_conent.replace(reg_s,"isDownload=Y&token="+this.URLTOKEN);
						//this.onSubmitRead(this.new_details.READ_STATUS);//更新阅读状态
						let reg_s=new RegExp('<img style="vertical-align: middle; margin-right: 2px;" src="/static/UEditor/dialogs/attachment/fileTypeImages','g')//g代表全部
						this.article_conent=this.article_conent.replace(reg_s,'<img style="vertical-align: middle; margin-right: 2px;width:16px !important;height:16px !important;" src="'+this.CoreNew.JOA_URL+'/static/UEditor/dialogs/attachment/fileTypeImages');
					}
				}
			 }.bind(this)).catch(function (error) { 
					//alert("请求--公司公告详细页--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--公司公告详细页--失败"+error);//记录错误
					console.log("请求--公司公告详细页--失败"+error); 
			 });
	   }
    }
};
</script>
